import { render, staticRenderFns } from "./LinkListModeForm.vue?vue&type=template&id=ad5984dc&scoped=true&"
import script from "./LinkListModeForm.vue?vue&type=script&lang=ts&"
export * from "./LinkListModeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5984dc",
  null
  
)

export default component.exports